import { NgModule } from "@angular/core";

import { Thumbnail, Makeurl, queryParamUrl } from "./thumbnail.pipe";
import { SecondToTime, MusicDuration } from "./minuits.pipe";
import { DaysConvertPipe } from "./days-convert.pipe";
import { CapitalizePipe } from "./capitalize.pipe";
import { LanguageTranslatePipe } from "./language-translate.pipe";
import { ViewdaysPipe } from "./viewdays.pipe";
import { limitToPipe } from "./limitTo.pipe";
import { removeDash } from "./removeDash.pipe";
import { decimalNumberPipe } from "./decimalNumber.pipe";
import { removeUnderScore } from "./removeDash.pipe";
import { timerValue } from "./timerValue.pipe";

@NgModule({
  declarations: [
    Thumbnail,
    SecondToTime,
    DaysConvertPipe,
    CapitalizePipe,
    LanguageTranslatePipe,
    Makeurl,
    ViewdaysPipe,
    limitToPipe,
    MusicDuration,
    removeDash,
    decimalNumberPipe,
    removeUnderScore,
    queryParamUrl,
    timerValue
  ],
  exports: [
    Thumbnail,
    SecondToTime,
    DaysConvertPipe,
    CapitalizePipe,
    LanguageTranslatePipe,
    Makeurl,
    ViewdaysPipe,
    limitToPipe,
    MusicDuration,
    removeDash,
    decimalNumberPipe,
    removeUnderScore,
    queryParamUrl,
    timerValue
  ],
})
export class PipeModule { }
